/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FiltersState {
  filtersData: any;
}

const initialState: FiltersState = {
  filtersData: null,
};

export const geoFiltersSlice = createSlice({
  name: 'geoFilters',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<any>) => {
      state.filtersData = action.payload;
    },
    clearFilters: (state) => {
      state.filtersData = null;
    },
  },
});

export const { setFilters, clearFilters } = geoFiltersSlice.actions;
export default geoFiltersSlice.reducer;
